import { IfacilityContact, IjobSignature } from '../../models';

export const OTHER_CONTACT_VALUE = 'other';

export interface IcustomerContactOption {
    value: string;
    label: string;
}

export interface IcustomerSelection {
    contactID: string;
    customerName: string;
}

export const contactDisplayName = (contact: IfacilityContact): string =>
    `${contact.user?.first || contact.firstName} ${contact.user?.last || contact.lastName}`;

const activeContacts = (contacts: IfacilityContact[]) => contacts.filter(contact => !contact.isDeleted);

export const buildCustomerContactOptions = (
    contacts: IfacilityContact[],
    otherLabel: string
): IcustomerContactOption[] => [
    ...activeContacts(contacts).map(contact => ({ value: contact.id, label: contactDisplayName(contact) })),
    { value: OTHER_CONTACT_VALUE, label: otherLabel }
];

export const resolveCustomerSelection = (
    customerSignature: IjobSignature | undefined,
    contacts: IfacilityContact[]
): IcustomerSelection => {
    if (!customerSignature) {
        return { contactID: '', customerName: '' };
    }

    const contact = activeContacts(contacts).find(c => c.id === customerSignature.contactID);
    if (contact) {
        return { contactID: contact.id, customerName: contactDisplayName(contact) };
    }

    if (customerSignature.signedBy) {
        return { contactID: OTHER_CONTACT_VALUE, customerName: customerSignature.signedBy };
    }

    return { contactID: '', customerName: '' };
};
